<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - Auksjonskoder</h4>
      </div>

      <div class="cell shrink">
        <router-link :to="{ name: 'InstillingerList' }" class="button primary transparent">Gå tilbake</router-link>
      </div>
    </div>

    <router-link :to="{ name: 'AuksjonAdd'}" class="button action fixed right">
      Ny Auksjon
    </router-link>

    <TheLoader :active="loading"/>

    <section class="content large-padding">
      <form @submit.prevent="handleSearchSubmit">
        <div class="grid-x grid-padding-x">
          <TheTextInput containerClassName="cell large-3" label="Auksjonskode / Beskrivelse" name="Auksjonskode" required v-validate="'required'" v-model.trim="filter.Auksjonskode"/>
          <TheSelectInput containerClassName="cell large-3" label="Avdeling" name="Avdelingsid" v-model="filter.Avdelingsid" :items="instillinger.avdeling"/>
          <TheSelectInput containerClassName="cell large-3" label="Status" name="Datestate" v-model="filter.Datestate" :items="instillinger.datestate"/>
          <div class="cell shrink">
            <label>&nbsp;</label>
            <button type="submit" class="button primary" v-if="!searching">Søk</button>
            <button type="submit" class="button primary loading" v-else>Søker...<span class="loader-spinner"></span></button>
          </div>
        </div>
      </form>
    </section>

    <table v-if="!loading" class="large fixed clickable" style="width: 100%" :style="{ opacity: searching ? 0.5 : 1 }">
      <thead>
        <tr>
          <th>#</th>
          <th>Auksjonskode</th>
          <th>Avdeling</th>
          <th>Beskrivelse</th>
          <th>Type</th>
          <th>Nettauksjon</th>
          <th>Auksjonsdato</th>
        </tr>
      </thead>
      <tbody v-if="items.length > 0">
        <tr v-for="item in items" v-bind:key="item.id" @click="editItem(item)">
          <td>{{item.Auksjonsid}}</td>
          <td>{{item.Auksjon}}</td>
          <td>{{ printAvdelingsName(item) }}</td>
          <td>{{item.Beskrivelse | truncate(50)}}</td>
          <td>{{item.Auksjontype}}</td>
          <td>{{item.Nettauksjon}}</td>
          <td>{{item.Auksjon_dato | avantidatetime}}</td>
        </tr>
      </tbody>
      <tbody v-else-if="!searching">
        <tr><td colspan="7"><em>Fant ingen auksjoner...</em></td></tr>
      </tbody>
    </table>

    <div class="pagination-container"  v-if="pages > 1 && !loading">
      <paginate v-model="page"
        :page-count="pages"
        :page-range="11"
        :click-handler="setPage"
        :container-class="'pagination'"
        :prev-text="paginationArrow"
        :next-text="paginationArrow"
        :prev-class="'prev'"
        :next-class="'next'"
        >
      </paginate>
    </div>
  </div>
</template>

<script>
import AuksjonService from '@/services/AuksjonService'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      page: 1,
      pages: 1,
      items: [],
      loading: true,
      searching: false,
      avdelingMap: null,
      filter: {
        Avdelingsid: null,
        Auksjonskode: null,
        Datestate: null
      },
      instillinger: {
        avdeling: [],
        type: [],
        datestate: [
          { key: null, val: 'Alle' },
          { key: 'finished', val: 'Avsluttede' },
          { key: 'upcoming', val: 'Kommende' },
          { key: 'notset', val: 'Auksjoner som savner dato' }
        ]
      }
    }
  },
  created () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1

    try {
      this.filter = JSON.parse(localStorage.inst_auk_filter)
    } catch (e) {
      this.filter = {
        Avdelingsid: null,
        Auksjonskode: null,
        Datestate: null
      }
    }

    this.fetch()
  },
  methods: {
    printAvdelingsName: function (item) {
      const itemId = Number(item.Avdelingsid)
      let found = this.avdelingMap.find(a => Number(a.key) === itemId)

      return found ? found.val : '-'
    },
    fetch: function (callback) {
      this.loading = true

      this.instillinger.avdeling.unshift({key: Number(this.filter.Avdelingsid), val: 'Laster...'})

      AuksjonService.loadFormDropdowns()
        .then((response) => {
          this.instillinger.avdeling = this._.clone(response.avdeling)
          this.instillinger.avdeling.unshift({key: null, val: 'Alle avdelinger'})

          this.avdelingMap = response.avdeling
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn instillinger')
        })
        .then(() => {
          this.loading = false

          // If previously searched, run the same search again...
          if (this.filter.Auksjonskode) {
            this.doSearch()
          }
        })
    },
    handleSearchSubmit: function () {
      if (this.loading || this.searching) {
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            console.log('Feil')
          } else {
            this.page = 1
            this.doSearch()
          }
        })
    },
    doSearch: function () {
      if (this.loading || this.searching) {
        return
      }

      this.searching = true

      localStorage.inst_auk_filter = JSON.stringify(this.filter)

      AuksjonService.searchInSettings(this.filter.Auksjonskode, this.filter.Avdelingsid, this.filter.Datestate, 'Auksjon_dato', 'DESC', this.page)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.items = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn auksjoner')
        })
        .then(() => {
          this.searching = false
        })
    },
    setPage: function (pageNum) {
      this.page = pageNum
      this.doSearch()
    },
    editItem: function (item) {
      this.$router.push({name: 'AuksjonEdit', params: {id: item.Auksjonsid}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerAuksjonList.vue